import React from "react";
import { Link } from "react-router-dom";
import Brand from "./Brand";

const Footer = () => (
  <footer className="xfoot">
    <div className="wrap">
      <div className="foot-grid">
        <div>
          <Brand />
          <p style={{ fontSize: 14, maxWidth: 280, marginTop: 10 }}>
            Beauty &amp; wellness booking for Jamaica. Mobile or in-salon, on your schedule.
          </p>
        </div>
        <div className="foot-links">
          <Link to="/#how">How it works</Link>
          <Link to="/#timeline">Launch</Link>
          <Link to="/#faq">FAQ</Link>
          <Link to="/privacy" data-testid="footer-privacy-link">Privacy Policy</Link>
          <Link to="/terms" data-testid="footer-terms-link">Terms of Service</Link>
        </div>
      </div>
      <div className="foot-bottom">
        <span>© 2026 Xandi Beauty &amp; Wellness Hub Limited. All rights reserved.</span>
        <span>hello@xandibwh.com · (876) 599-4444 · xandibwh.com</span>
      </div>
    </div>
  </footer>
);

export default Footer;
